/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from 'react';

// Move countries array outside the component to prevent recreation on each render
const SUPPORTED_COUNTRIES = [
    {
        id: 1,
        name: 'Kenya',
        countryCode: 'KE',
        currency: 'KES'
    },
    {
        id: 2,
        name: 'Zambia',
        countryCode: 'ZM',
        currency: 'ZMW'
    }
];

const CurrencyFormatter = ({ value }) => {
    const [currencyInfo, setCurrencyInfo] = useState({
        currency: 'KES',
        countryCode: 'KE'
    });

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getUserLocation = async () => {
            try {
                // Try browser geolocation
                if ('geolocation' in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        async (position) => {
                            try {
                                const { latitude, longitude } = position.coords;
                                const geoResponse = await fetch(
                                    `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
                                );
                                const geoData = await geoResponse.json();
                                if (geoData && geoData.countryCode) {
                                    const matchedCountry = SUPPORTED_COUNTRIES.find(
                                        (country) => country.countryCode === geoData.countryCode
                                    );

                                    if (matchedCountry) {
                                        setCurrencyInfo({
                                            currency: matchedCountry.currency,
                                            countryCode: matchedCountry.countryCode
                                        });
                                    }
                                }
                            } catch (error) {
                                console.error('Error getting location details:', error);
                            } finally {
                                setIsLoading(false);
                            }
                        },
                        (error) => {
                            setIsLoading(false);
                        }
                    );
                } else {
                    setIsLoading(false);
                }
            } catch (error) {
                console.error('Error detecting user location:', error);
                setIsLoading(false);
            }
        };

        getUserLocation();

        // Set a timeout to ensure we don't wait forever
        const timeout = setTimeout(() => {
            setIsLoading(false);
        }, 3000);

        return () => clearTimeout(timeout);
    }, []);

    const formattedValue = useMemo(() => {
        return new Intl.NumberFormat(`en-${currencyInfo.countryCode}`, {
            style: 'currency',
            currency: currencyInfo.currency,
            maximumFractionDigits: 0
        }).format(value);
    }, [currencyInfo.countryCode, currencyInfo.currency, value]);

    return <span>{formattedValue}</span>;
};

export default CurrencyFormatter;
